// Configure which target apps are available for article posting metadata.
// Only entries with a non-empty jsonMetadata object will appear in the UI.
const ARTICLE_TARGET_APPS = {
  flexus: {
    label: 'Flexus',
    jsonMetadata: {
      app: 'flexus/0.1-rcc', sourced: "Flexus"
    }
  },
  inleo: {
    label: 'InLeo',
    jsonMetadata: {
      app: 'leothreads/0.3', sourced: "Flexus"
    }
  },
  peakd: {
    label: 'PeakD',
    jsonMetadata: {
      app: 'peakd/2026.1.4-f', sourced: "Flexus"
    }
  },
  ecency: {
    label: 'Ecency',
    jsonMetadata: {
      app: 'ecency/4.3.7-vision-f', sourced: "Flexus"
    }
  },
  hiveblog: {
    label: 'Hive.blog',
    jsonMetadata: {
      app: 'hiveblog/0.1-f', sourced: "Flexus"
    }
  }
};

export const getAvailableArticleTargetApps = () => {
  return Object.entries(ARTICLE_TARGET_APPS)
    .filter(([, config]) => config && config.jsonMetadata && Object.keys(config.jsonMetadata).length > 0)
    .map(([key, config]) => ({
      key,
      label: config.label || key,
      jsonMetadata: config.jsonMetadata
    }));
};

export const buildArticleMetadataForTargetApp = (targetAppKey, baseMetadata = {}) => {
  const selectedConfig = ARTICLE_TARGET_APPS[targetAppKey];
  if (!selectedConfig || !selectedConfig.jsonMetadata) {
    return { ...baseMetadata };
  }

  return {
    ...baseMetadata,
    ...selectedConfig.jsonMetadata
  };
};

export default ARTICLE_TARGET_APPS;
